import { useDisclosure } from '@chakra-ui/react';
import {
  Flex,
  FlexProps,
  Icon,
  IconButton,
  IconName,
  Link,
  LinkProps,
  Paragraph
} from '../../atoms';

type Props = {
  title: string;
  link?: LinkProps & { label: string };
  canBeClosed?: boolean;
  withGradient?: boolean;
} & FlexProps;

export function SnackBar({
  link,
  title,
  canBeClosed = true,
  withGradient = true,
  ...rest
}: Props): JSX.Element {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  if (!isOpen) {
    return <></>;
  }
  return (
    <Flex
      data-testid="side-overlay"
      justifyContent="center"
      alignItems="center"
      bgGradient={
        withGradient ? 'linear(to-r, #E7F1F9 0%, #F8EEFE 100%)' : 'none'
      }
      h="60px"
      {...rest}
    >
      <Flex flexGrow={1} justifyContent="center" alignItems="center">
        <Paragraph size="sm" fontWeight="semibold">
          {title}
        </Paragraph>
        {link && (
          <Link
            target="_blank"
            textDecoration="underline"
            to={link.to}
            ml="space_unit.x1"
          >
            <Paragraph size="sm" fontWeight="semibold">
              {link.label}
            </Paragraph>
          </Link>
        )}
      </Flex>
      {canBeClosed && (
        <IconButton
          variant="unstyled"
          border="none"
          aria-label="close"
          onClick={onClose}
          mr="space_unit.x4"
          icon={<Icon w="24px" h="24px" name={IconName.Close} />}
        />
      )}
    </Flex>
  );
}
